export default {"src":"/_next/static/media/mail-gray.65b0c6f3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};